export default function COUNT() {
  return (
    <div className="p-4">
      <h1>COUNT</h1>
    </div>
  );
}
